import * as angular from 'angular';
import {IController, IScope} from "angular";
import {DeliveriesService} from "../../services/deliveries-service.service";

//dialog example without scope

export class serviceListItemCtrl implements IController {
  service: any;

  /* @ngInject */
  constructor(private $mdDialog, private $scope: IScope, private deliveriesService: DeliveriesService, private splitService) {
  }

  $onInit() {}

  onOpenPriceDialog(event, service) {
    this.deliveriesService.getDeliveryBilling(service.id).then((billing)=>{
      this._openDialog(event, service, billing);
    })
  }

  private _openDialog(event, service, billing) {

    this.$mdDialog.show({
      template : '<service-pricing service="vm.service" billing="vm.billing"></service-pricing>',
      parent : angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose : true,
      bindToController: true,
      locals: {
        service: service,
        billing: billing
      },
      controllerAs: 'vm',
      controller: function () {
      }
    });
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('servicePricePopUp', {
    bindings: {
      service: '<'
    },
    template: require('./service-price-pop-up.html').default,
    controller: serviceListItemCtrl
  });
